import '@miro-site/shared-types'
import React, {useEffect} from 'react'

import {TemplateOpenerProvider} from '@miro-site/core'
import {RichTextOptionsProvider, BLOCKS} from '@miro-site/ui-design-system'
import {ServicesProvider} from '@miro-site/services'
import {LocalizationProvider} from '@miro-site/localization'

import {SectionRenderer} from '@miro-site/section-components'

const sectionRendererOption = {
  [BLOCKS.EMBEDDED_ENTRY]: node => {
    const component = node.data.target.fields?.component

    return (
      <div data-component={component?.component}>
        <SectionRenderer section={component} />
      </div>
    )
  },
}

import {initializeCloudwatch} from '../src/system/cloudwatch'

initializeCloudwatch()

const LPBuilderPages = ({Component, pageProps}) => {
  useEffect(() => {
    /**
     * Legacy scripts aren't needed on new bootstrap pages
     */
    if (pageProps?.styleSystem !== 'bootstrap') {
      handleLegacyInit()
    }
  }, [pageProps?.styleSystem])

  const handleLegacyInit = async () => {
    const initLegacy = (await import('@miro-site/section-components')).initLegacy
    initLegacy()
  }

  const pageLocale = pageProps.page?.sys?.locale || 'en'

  return (
    <ServicesProvider>
      <TemplateOpenerProvider>
        <LocalizationProvider
          detectLocale={false}
          detectTranslations={false}
          data={{
            currentLocale: pageLocale,
            translations: pageProps.translations?.map(t => ({
              locale: t.locale,
              url: t.url ? `/${t.url}/` : '/',
            })),
          }}
        >
          <RichTextOptionsProvider options={{renderNode: sectionRendererOption}}>
            <Component {...pageProps} />
          </RichTextOptionsProvider>
        </LocalizationProvider>
      </TemplateOpenerProvider>
    </ServicesProvider>
  )
}

export default LPBuilderPages
